export default __webpack_public_path__ + "static/media/2_0054.5f6bfa80.webp";